import { render, staticRenderFns } from "./KontaktPage.vue?vue&type=template&id=7237690c&"
import script from "./KontaktPage.vue?vue&type=script&lang=js&"
export * from "./KontaktPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports